<script setup lang="ts">
import { ref } from 'vue';
import { useToast } from 'primevue/usetoast';
import { PersonStores, useAuthStore } from '@/store';

const profileStore = PersonStores.useUserProfileStore();
const authStore = useAuthStore();
const confirmResetPasswordOpen = ref(false);
const toast = useToast();

const onCancelResetPassword = () => (confirmResetPasswordOpen.value = false);

const openConfirmResetPassword = () => (confirmResetPasswordOpen.value = true);

const onResetPassword = () => {
  authStore
    .forgotPassword({ email: profileStore.person?.user?.email, causer_id: authStore.user?.id })
    .then((response) => {
      if (response.data.success) {
        doSuccess(response.data.message);
      } else {
        doWarn(response.data.message);
      }
    })
    .catch((error) => doFail(error.data.message));

  confirmResetPasswordOpen.value = false;
};

const doSuccess = (detail: string) => {
  toast.add({
    severity: 'success',
    summary: 'Reset Link Sent',
    detail: detail,
    life: 3000,
  });
};

const doFail = (detail: string) => {
  toast.add({
    severity: 'warn',
    summary: 'Error',
    detail: detail,
    life: 3000,
  });
};

const doWarn = (detail: string) => {
  toast.add({
    severity: 'warn',
    detail: detail,
    life: 3000,
  });
};
</script>

<template>
  <div>
    <ConfirmAction
      v-if="confirmResetPasswordOpen"
      header="Reset Password"
      accept-label="Reset Password"
      @accept="onResetPassword"
      @cancel="onCancelResetPassword"
    >
      <div class="flex text-gray-800">
        <Icon name="warning" class="confirm-dialog-icon text-gray-600" />
        <span class="w-10 pl-3">
          {{ `Are you sure you want to Reset ${profileStore.person?.display_name}'s Password?` }}
        </span>
      </div>
    </ConfirmAction>
    <AppButton type="secondary" text="Reset Password" icon-left="vpn_key" @click="openConfirmResetPassword" />
  </div>
</template>
